import AllSectionItems from '../Components/AllSectionItems';
import CreateSectionItem from '../Components/CreateSectionItem';

export const SectionItemRoutes = [
  {
    Component: AllSectionItems,
    path: "/all",
    exact: true,
    id: "dashboardSectionItemsAll",
    routePath: "/dashboard/section-items/all",
    name: "All Section Items"
  },
  {
    Component: CreateSectionItem,
    path: '/edit/:id',
    exact: true,
    id: 'dashboardSectionItemsEdit',
  },
  {
    Component: CreateSectionItem,
    path: "/create",
    exact: true,
    id: "dashboardSectionItemsCreate",
    routePath: "/dashboard/section-items/create",
    name: "Create Section Item"
  }
];
